export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}
export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}
